export function configurarLightbox(scheduler, sections) {
  // Labels en español para los campos del formulario
  scheduler.locale.labels.section_descripcion = 'Descripción'
  scheduler.locale.labels.section_tipo = 'Tipo'
  scheduler.locale.labels.section_cliente = 'Cliente'
  scheduler.locale.labels.section_pedido = 'Pedido'
  scheduler.locale.labels.section_articulo = 'Artículo'
  scheduler.locale.labels.section_cantidad = 'Cantidad'
  scheduler.locale.labels.section_maquina = 'Máquina'
  scheduler.locale.labels.section_time = 'Periodo'
  scheduler.locale.labels.section_duracion = 'Duración (horas)'
  scheduler.locale.labels.section_codigo_horno = 'Horno'
  scheduler.locale.labels.section_esmalte_equivalente = 'Esmalte Equivalente'

  // Helper: duración en horas (recibe el valor del campo duracion_horas directamente)
  const calcDuracion = (value) => {
    if (value != null && value > 0) {
      return Math.round(value * 10) / 10 + ' h'
    }
    return '-'
  }

  // Obtener lista de máquinas para el selector
  const yOptions = sections.map((s) => ({
    key: s.key,
    label: s.label,
  }))

  // Formulario para ACTIVIDAD (el más completo)
  const sectionsActividad = [
    {
      name: 'descripcion',
      height: 60,
      type: 'textarea',
      map_to: 'text',
      focus: true,
    },
    {
      name: 'tipo',
      height: 26,
      type: 'template',
      map_to: 'tipo',
      template: function (ev) {
        return `<span style="font-weight:500">${ev.tipo || '-'}</span>`
      },
    },
    {
      name: 'cliente',
      height: 26,
      type: 'template',
      map_to: 'cliente',
      template: function (ev) {
        return ev.cliente || '-'
      },
    },
    {
      name: 'pedido',
      height: 26,
      type: 'template',
      map_to: 'pedido',
      template: function (ev) {
        return ev.pedido || '-'
      },
    },
    {
      name: 'articulo',
      height: 26,
      type: 'template',
      map_to: 'articulo',
      template: function (ev) {
        return ev.articulo || '-'
      },
    },
    {
      name: 'esmalte_equivalente',
      height: 26,
      type: 'template',
      map_to: 'esmalte_equivalente',
      template: function (ev) {
        return ev.esmalte_equivalente || '-'
      },
    },
    {
      name: 'cantidad',
      height: 26,
      type: 'template',
      map_to: 'cantidad',
      template: function (ev) {
        return ev.cantidad || '-'
      },
    },
    {
      name: 'codigo_horno',
      height: 26,
      type: 'template',
      map_to: 'codigo_horno',
      template: function (ev) {
        return ev.codigo_horno || '-'
      },
    },
    {
      name: 'duracion',
      height: 26,
      type: 'template',
      map_to: 'duracion_horas',
      template: calcDuracion,
    },
    {
      name: 'maquina',
      height: 32,
      type: 'select',
      map_to: 'section_id',
      options: yOptions,
    },
    {
      name: 'time',
      height: 72,
      type: 'time',
      map_to: 'auto',
    },
  ]

  // Formulario para TRANSICIÓN (simplificado)
  const sectionsTransicion = [
    {
      name: 'descripcion',
      height: 40,
      type: 'template',
      map_to: 'text',
      template: function (ev) {
        return ev.text || 'Transición'
      },
    },
    {
      name: 'tipo',
      height: 26,
      type: 'template',
      map_to: 'tipo_transicion',
      template: function (ev) {
        return ev.tipo_transicion || ev.tipo || '-'
      },
    },
    {
      name: 'duracion',
      height: 26,
      type: 'template',
      map_to: 'duracion_horas',
      template: calcDuracion,
    },
    {
      name: 'codigo_horno',
      height: 26,
      type: 'template',
      map_to: 'codigo_horno',
      template: function (ev) {
        return ev.codigo_horno || '-'
      },
    },
    {
      name: 'maquina',
      height: 32,
      type: 'select',
      map_to: 'section_id',
      options: yOptions,
    },
    {
      name: 'time',
      height: 72,
      type: 'time',
      map_to: 'auto',
    },
  ]

  // Formulario para ARRANQUE (muy simplificado)
  const sectionsArranque = [
    {
      name: 'descripcion',
      height: 40,
      type: 'template',
      map_to: 'text',
      template: function (ev) {
        return ev.text || 'Arranque'
      },
    },
    {
      name: 'tipo',
      height: 26,
      type: 'template',
      map_to: 'tipo',
      template: function (ev) {
        return ev.tipo || '-'
      },
    },
    {
      name: 'duracion',
      height: 26,
      type: 'template',
      map_to: 'duracion_horas',
      template: calcDuracion,
    },
    {
      name: 'codigo_horno',
      height: 26,
      type: 'template',
      map_to: 'codigo_horno',
      template: function (ev) {
        return ev.codigo_horno || '-'
      },
    },
    {
      name: 'maquina',
      height: 32,
      type: 'select',
      map_to: 'section_id',
      options: yOptions,
    },
    {
      name: 'time',
      height: 72,
      type: 'time',
      map_to: 'auto',
    },
  ]

  // Formulario para OCUPADA
  const sectionsOcupada = [
    {
      name: 'descripcion',
      height: 40,
      type: 'template',
      map_to: 'text',
      template: function (ev) {
        return ev.text || 'Ocupada'
      },
    },
    {
      name: 'tipo',
      height: 26,
      type: 'template',
      map_to: 'tipo',
      template: function (ev) {
        return ev.tipo || '-'
      },
    },
    {
      name: 'pedido',
      height: 26,
      type: 'template',
      map_to: 'pedido',
      template: function (ev) {
        return ev.pedido || '-'
      },
    },
    {
      name: 'articulo',
      height: 26,
      type: 'template',
      map_to: 'articulo',
      template: function (ev) {
        return ev.articulo || '-'
      },
    },
    {
      name: 'esmalte_equivalente',
      height: 26,
      type: 'template',
      map_to: 'esmalte_equivalente',
      template: function (ev) {
        return ev.esmalte_equivalente || '-'
      },
    },
    {
      name: 'codigo_horno',
      height: 26,
      type: 'template',
      map_to: 'codigo_horno',
      template: function (ev) {
        return ev.codigo_horno || '-'
      },
    },
    {
      name: 'duracion',
      height: 26,
      type: 'template',
      map_to: 'duracion_horas',
      template: calcDuracion,
    },
    {
      name: 'maquina',
      height: 32,
      type: 'select',
      map_to: 'section_id',
      options: yOptions,
    },
    {
      name: 'time',
      height: 72,
      type: 'time',
      map_to: 'auto',
    },
  ]

  // Configuración por defecto
  scheduler.config.lightbox.sections = sectionsActividad

  // Evento onBeforeLightbox
  scheduler.attachEvent('onBeforeLightbox', function (id) {
    const ev = scheduler.getEvent(id)
    if (!ev) return true

    const tipo = ev.tipo || 'Actividad'

    if (tipo === 'Transición') {
      scheduler.config.lightbox.sections = sectionsTransicion
    } else if (tipo === 'Arranque' || tipo === 'Arrancada') {
      scheduler.config.lightbox.sections = sectionsArranque
    } else if (tipo === 'Ocupada') {
      scheduler.config.lightbox.sections = sectionsOcupada
    } else {
      // Por defecto: Actividad
      scheduler.config.lightbox.sections = sectionsActividad
    }

    // Resetear el lightbox para que aplique la nueva configuración
    scheduler.resetLightbox()
    return true
  })

  // Template Header
  scheduler.templates.lightbox_header = function (start, end, ev) {
    const formatDate = (date) => {
      return date.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    }

    return (ev.text || ev.tipo || 'Evento') + ' — ' + formatDate(start) + ' → ' + formatDate(end)
  }
}

export function configurarBloqueoEdicion(scheduler) {
  function isLocked(ev) {
    const tipo = ev?.tipo || 'Actividad'
    return tipo !== 'Actividad'
  }

  scheduler.attachEvent('onBeforeDrag', function (id, mode, e) {
    const ev = scheduler.getEvent(id)
    return !isLocked(ev)
  })

  scheduler.attachEvent('onBeforeEventChanged', function (ev, e, is_new, original) {
    return !isLocked(ev)
  })
}
